import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HomeInfo.scss';

const HomeInfo = () => {
  return (
    <div className='home-info'>
      <Container>
        <Row>
          <Col>
            <h2 className='home-info__title'>Kost Khusus Putri Jakarta Selatan</h2>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 4, offset: 2 }}>
            <p className='home-info__text'>House of Arie menghadirkan tempat tinggal yang dirancang untuk kenyamanan para penghuni dengan
              menghadirkan Kost Khusus Putri yang nyaman dan aman. Terinspirasi oleh energi positif dari lingkungan
              muda, kreatif, dan beragam di kawasan Jakarta Selatan. Ini tercermin dalam desain fungsional dan modern
              yang dilapisi dengan dekorasi dan detail yang hangat.</p>
          </Col>
          <Col md={4}>
            <p className='home-info__text'>Kami mempromosikan konsep hidup di lingkungan yang nyaman dan aman, cocok untuk mahasiswi, pekerja yang
              bekerja di daerah sekitarnya.</p>
            <p className='home-info__text'>Dinamai “House”, House of Arie dimaksudkan sebagai tempat yang bisa membuat
              orang merasa seperti di rumah sendiri.</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomeInfo;
